const locale = {
    placeholder: '請選擇時間',
    rangePlaceholder: ['開始時間', '結束時間'],
};
export default locale;
